// TODO: Use coverColors gradient when coverPhoto is null/empty, use actual coverPhoto image when set.
// Replace DEFAULT_COVER with real publisher cover photos once assets are available.
const COVER_MAP = {
    'featured-epl': '/assets/cover/epl.webp',
};

const DEFAULT_COVER = '/assets/cover/ecal-default-cover.jpg';

export function assignCoverPhotos(publishers) {
    return publishers.map((p, index) => {
        if (COVER_MAP[p.id]) {
            return { ...p, coverPhoto: COVER_MAP[p.id] };
        }
        // Every 3rd item falls back to the coverColors gradient
        if (index % 3 === 0) {
            return { ...p, coverPhoto: null };
        }
        return { ...p, coverPhoto: DEFAULT_COVER };
    });
}
